import React from 'react';
import ReactDOM from 'react-dom/client';
import PPCDashboard from './PPCDashboard';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PPCDashboard />
  </React.StrictMode>
);
